<template>
  <v-row justify="center" style="position: absolute">
    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      top
      multi-line
      :color="snackbarColor"
      right
    >
      {{ textNotification }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="info"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog"  persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Вы уверены?</v-card-title>
        <v-card-text>{{text}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false">Отмена</v-btn>
          <v-btn color="green darken-1" text @click="call">Ок</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="saving"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="teal"
      >
        <v-card-text class="white--text">
          Идёт сохранение....
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name: "ModalAgree",

    created() {
      bus.$on('modalAgree', (payload) => {
        this.text = payload.text;
        this.dialog = true
        this.callback = payload.callback;
        this.params = payload.params;
      })
      bus.$on('savingModal', (payload) => {
        this.saving = true
      })

      bus.$on('notificationAlert', (payload) => {
        this.snackbar = true
        this.textNotification = payload.text;
        this.snackbarColor = payload.color
      })

      bus.$on('endSavingModal', (payload) => {
       setTimeout(() => {
         this.saving = false
       }, 1000)
      })
    },
    methods:{
      call(){
        this.callback(this.params);
        this.dialog = false;
      }
    },
    data() {
      return {
        snackbarColor : null,
        textNotification: '',
        snackbar : false,
        saving: false,
        params : {},
        dialog: false,
        callback : null,
        text : '',
      }
    }
  }
</script>

<style scoped>

</style>
